function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var expandMargin = function(margin) {
    if (!!margin || margin === 0) {
        if (typeof margin === 'number') {
            return {
                marginEnd: margin,
                marginStart: margin
            };
        }
        if (margin !== null) {
            return _objectSpread({}, (margin === null || margin === void 0 ? void 0 : margin.start) ? {
                marginStart: margin.start
            } : {}, (margin === null || margin === void 0 ? void 0 : margin.end) ? {
                marginEnd: margin.end
            } : {}, (margin === null || margin === void 0 ? void 0 : margin.top) ? {
                marginTop: margin.top
            } : {}, (margin === null || margin === void 0 ? void 0 : margin.bottom) ? {
                marginBottom: margin.bottom
            } : {});
        }
    }
    return {
        marginEnd: 0,
        marginStart: 0
    };
};
var defineStartAndEnd = function(isRtl) {
    return isRtl ? {
        start: 'Right',
        end: 'Left'
    } : {
        start: 'Left',
        end: 'Right'
    };
};
var useStyle = function(param) {
    var minHeight = param.minHeight, justifyContent = param.justifyContent, _flexGrow = param.flexGrow, flexGrow = _flexGrow === void 0 ? 0 : _flexGrow, isRtl = param.isRtl, margin = param.margin, zIndex = param.zIndex;
    var ref = defineStartAndEnd(isRtl), start = ref.start, end = ref.end;
    var expandedMargin = expandMargin(margin) || {};
    var row = function() {
        var totalMargin = (expandedMargin.marginStart || 0) + (expandedMargin.marginEnd || 0);
        return {
            zIndex: zIndex,
            direction: isRtl === true && 'rtl' || isRtl === false && 'ltr' || 'inherit',
            boxSizing: 'border-box',
            width: totalMargin ? "calc(100% - ".concat(totalMargin, "px)") : '100%',
            display: 'flex',
            flexWrap: 'wrap',
            flexShrink: 0,
            flexGrow: flexGrow,
            flexBasis: 'auto',
            alignItems: 'stretch',
            minHeight: minHeight
        };
    };
    var rowJustifyContent = function() {
        switch(justifyContent){
            case 'center':
                return {
                    justifyContent: 'center'
                };
            case 'end':
                return {
                    justifyContent: 'flex-end'
                };
            case 'flex-end':
                return {
                    justifyContent: 'flex-end'
                };
            default:
                return {
                    justifyContent: 'flex-start'
                };
        }
    };
    var rowMargin = function() {
        var marginStart = expandedMargin.marginStart, marginEnd = expandedMargin.marginEnd, marginTop = expandedMargin.marginTop, marginBottom = expandedMargin.marginBottom;
        return _objectSpread({}, marginStart ? _defineProperty({}, "margin".concat(start), "".concat(marginStart, "px")) : {}, marginEnd ? _defineProperty({}, "margin".concat(end), "".concat(marginEnd, "px")) : {}, marginTop ? {
            marginTop: marginTop
        } : {}, marginBottom ? {
            marginBottom: marginBottom
        } : {});
    };
    return _objectSpread({}, row(), rowJustifyContent(), rowMargin());
};
export default useStyle;
